<template>
    <div class="learner__tag_grid__wrapper" id="dataTagGrid">
        <div class="section__title__box">
            <h4 class="title">Tag Grid</h4>
            <div class="color__key__select">
                <div class="select__option" :class="{ active: showColorKeyDropdown }"
                    @click="showColorKeyDropdown = !showColorKeyDropdown">
                    <span class="select__text">Color Key</span>
                    <span class="select__icon"
                        :style="{ transform: showColorKeyDropdown ? 'rotate(180deg)' : 'none' }">
                        <img :src="arrowDown" /></span>
                </div>
                <div class="color__key__dropdown" :class="{ active: showColorKeyDropdown }" v-show="showColorKeyDropdown">
                    <table>
                        <thead>
                            <tr>
                                <th><span class="head__item" style="width: 113px;">Color</span></th>
                                <th><span class="head__item" style="width: 228px;">Tester</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(color, index) in tagGridData?.assessmentsColors" :key="index">
                                <td>
                                    <span :style="`background: ${color}`"></span>
                                </td>
                                <td>
                                    <span class="color__title">Assessment {{ Number(index) + 1 }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="divider__sepline"></div>

        <div class="main__grid__table__wrapper">
            <div class="table__inner__cover">
                <div class="table__y__wrap">
                    <span v-for="num in 6" :key="num">{{ 7 - num }}</span>
                </div>

                <div class="table__box__wrapper">
                    <table>
                        <tbody>
                            <!-- Static first 3 rows -->
                            <tr v-for="i in 3" :key="'static-' + i">
                                <td>
                                    <div class="inner__table__data"><span>V</span><span>C</span></div>
                                </td>
                                <td v-for="j in 3" :key="j" class="brown__box">
                                    <div class="inner__table__data">
                                        <span style="font-size: 0;">V</span>
                                        <span style="font-size: 0;">C</span>
                                    </div>
                                </td>
                            </tr>

                            <!-- Dynamic rows from finalColors -->
                            <tr class="purple__box" v-for="(rowIndex) in Array.from({ length: 3 }, (_, i) => 2 - i)"
                                :key="'dyn-' + rowIndex">
                                <td class="purple__box" v-for="i in 4" :key="i">
                                    <div class="inner__table__data">
                                        <!-- Optional: Display rowIndex or index -->
                                        <span
                                            :style="getTagGridStyle(tagGridData?.finalColors?.[rowIndex]?.v?.[i - 1])">V</span>
                                        <span
                                            :style="getTagGridStyle(tagGridData?.finalColors?.[rowIndex]?.c?.[i - 1])">C</span>
                                    </div>
                                </td>
                            </tr>

                            <tr class="table__box__last_tr">
                                <td v-for="i in 4" :key="'bottom-' + i">{{ i }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref } from 'vue';
import arrowDown from '@/assets/images/arrow-down.png';

const showColorKeyDropdown = ref(false);

defineProps({
    tagGridData: {
        type: Object,
        required: true
    }
});

const getTagGridStyle = (entry) => {
    if (!entry) return '';
    const bg = entry.color ? `background: ${entry.color};` : '';
    const border = entry.borderColor ? `border: 3px solid ${entry.borderColor};` : '';
    return bg + border;
}
</script>
